import React from 'react';
import EnterSeatDetail from './EnterSeatDetail';
import { useSelector } from 'react-redux';

function SeatParticipants({ eventId, boxId, isHavingSeatPrice, isPaymentReq }) {
  const seatInfo = useSelector((state) => state.seatInfo);

  const renderFunc = () => {
    const item = seatInfo.selectedSeats.map((seat) => {
      return (
        <EnterSeatDetail
          seat={seat}
          eventId={eventId}
          boxId={boxId}
          key={seat.seatName}
          isHavingSeatPrice={isHavingSeatPrice}
          isPaymentReq={isPaymentReq}
        />
      );
    });

    return item;
  };

  return renderFunc();
}

export default SeatParticipants;
